import { Outlet } from "react-router-dom";
import Navigation from "./Navigation";
import Footer from "./Footer";
import MobileCallButton from "./MobileCallButton";

// Layout wrapper for all pages except HomePage
// HomePage has its own Navigation and Footer integrated
export default function Layout() {
  return (
    <>
      <Navigation />
      <main className="min-h-screen pt-16 md:pt-20">
        <Outlet />
      </main>
      <Footer />
      <MobileCallButton />
    </>
  );
}
